import { z } from "zod";
import { PublicLocales } from "./locales.js";
const PublicArticleSourceLocaleSchema = z.enum(PublicLocales.map(({ locale }) => locale));
export const PublicArticleSummarySchema = z.object({
    slug: z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    icon: z.string().min(1),
    title: z.string().min(1),
    description: z.string().min(1),
    category: z.string().min(1),
    readTime: z.string().min(1),
    lastModified: z.string().min(1),
    contentId: z.string().min(1),
    sourceLocale: PublicArticleSourceLocaleSchema,
    shared: z.boolean(),
});
export const PublicArticleSchema = PublicArticleSummarySchema.extend({
    markdown: z.string(),
});
export const PublicArticleDirectoryResponseSchema = z.object({
    articles: z.array(PublicArticleSummarySchema),
});
export const PublicArticlePageResponseSchema = PublicArticleDirectoryResponseSchema.extend({
    article: PublicArticleSchema,
});
//# sourceMappingURL=articles.js.map